import { render } from "./InsightsPanel.vue?vue&type=template&id=7b94a9bc&scoped=true"
import script from "./InsightsPanel.vue?vue&type=script&lang=js"
export * from "./InsightsPanel.vue?vue&type=script&lang=js"

import "./InsightsPanel.vue?vue&type=style&index=0&id=7b94a9bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b94a9bc"]])

export default __exports__